import { Component, type ErrorInfo, type ReactNode } from "react";
import { MusicNoteIcon } from "./DetailIcons";

type State = { failed: boolean };

export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Yours Music render error", error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="app-error" role="alert">
        <MusicNoteIcon size={42} />
        <h1>Yours Music needs a refresh</h1>
        <p>Something interrupted this screen. Your account and listening preferences are still safe.</p>
        <div>
          <button onClick={() => window.location.reload()}>Try again</button>
          <a href="/">Go home</a>
        </div>
      </main>
    );
  }
}
